const titles = {
  home: "Leadtech.az: elektronika və məişət texnika internet mağazası",
  category: "Leadtech.az: elektronika və məişət texnika internet mağazası",
  contact: "Leadtech.az: Əlaqə nömrəsi: (+994)10 260 39 02. Elektronika və məişət texnika internet mağazası",
  product: "Leadtech.az: Məhsul || elektronika və məişət texnika internet mağazası",
  categorySub: "Leadtech.az: elektronika və məişət texnika internet mağazası",
};

export default titles;
